import { render, staticRenderFns } from "./ProductCategoryTagView.vue?vue&type=template&id=47fc2b46&"
import script from "./ProductCategoryTagView.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryTagView.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryTagView.vue?vue&type=style&index=0&id=47fc2b46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports